import Route from '@ember/routing/route';
import { service } from '@ember/service';
import Utils from '../utils/utils';

export default class BrowserRoute extends Route {
    @service('aditools-site') siteconfig;
    @service urlData;
    @service intl;

    model(params) {
        let configData = Utils.getConfigData(params);
        return this.siteconfig
            .start(configData.url, configData.rootURL, configData.language, this.intl.locales)
            .then((/*site*/) => {
                //this.intl.setLocale(this.siteconfig.FullLocale === 'ru-ru' ? 'en-us' : this.siteconfig.FullLocale);
                this.intl.setLocale(this.siteconfig.FullLocale);
                this.urlData.load();
            });
    }
}
